import { Race } from "../Model/Race";
import ChallengePoint from "../Model/ChallengePoint";
export class RaceService {
    async saveRace(race) {
        localStorage.setItem('has_race', '1');
        localStorage.setItem('race', JSON.stringify(race.getState()));
    }
    async hasRace() {
        return !!localStorage.getItem('has_race');
    }
    async loadRace() {
        if (!this.hasRace()) {
            throw new Error('No hay ninguna carrera guardada.');
        }
        const raceState = JSON.parse(localStorage.getItem('race'));
        const startTime = new Date(raceState.startTime);
        const endTime = raceState.endTime ? new Date(raceState.endTime) : null;
        return new Race(raceState.routeId, raceState.startCheckpointId, startTime, raceState.challengePoints.map(challengePointState => new ChallengePoint(challengePointState)), raceState.track, raceState.points, raceState.isEnded, endTime);
    }
    clearRace() {
        localStorage.removeItem('has_race');
        localStorage.removeItem('race');
    }
}
